(() => {
  const roots = document.querySelectorAll('[data-elov-article]');

  roots.forEach((root) => {
    const content = root.querySelector('[data-article-content]');
    if (!content) return;

    const headings = [...content.querySelectorAll('h2, h3')].filter((heading) => {
      return !heading.closest('[data-skip-toc]');
    });
    const tocContainers = root.querySelectorAll('[data-toc]');
    const usedIds = new Set();

    const slugify = (value) => value
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');

    headings.forEach((heading, index) => {
      let id = heading.id || slugify(heading.textContent) || `section-${index + 1}`;
      const base = id;
      let suffix = 2;
      while (usedIds.has(id)) id = `${base}-${suffix++}`;
      usedIds.add(id);
      heading.id = id;
    });

    tocContainers.forEach((container) => {
      let sectionNumber = 0;
      headings.forEach((heading) => {
        const link = document.createElement('a');
        if (heading.tagName === 'H2') sectionNumber += 1;
        link.href = `#${heading.id}`;
        link.textContent = `${heading.tagName === 'H2' ? `${sectionNumber} ` : ''}${heading.textContent}`;
        link.dataset.level = heading.tagName === 'H3' ? '3' : '2';
        link.dataset.target = heading.id;
        container.appendChild(link);
      });
    });

    const tocLinks = [...root.querySelectorAll('[data-toc] a')];
    const setActive = (id) => {
      tocLinks.forEach((link) => link.classList.toggle('is-active', link.dataset.target === id));
    };

    if ('IntersectionObserver' in window && headings.length) {
      const observer = new IntersectionObserver((entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
        if (visible.length) setActive(visible[0].target.id);
      }, { rootMargin: '-18% 0px -68% 0px', threshold: 0 });
      headings.forEach((heading) => observer.observe(heading));
      setActive(headings[0].id);
    }

    const progress = root.querySelector('[data-reading-progress]');
    if (progress) {
      const updateProgress = () => {
        const bodyRect = content.getBoundingClientRect();
        const travelled = Math.max(0, -bodyRect.top + window.innerHeight * .3);
        const available = Math.max(1, content.offsetHeight - window.innerHeight * .55);
        progress.style.width = `${Math.min(100, travelled / available * 100)}%`;
      };
      document.addEventListener('scroll', updateProgress, { passive: true });
      updateProgress();
    }

    const copyButton = root.querySelector('[data-copy-link]');
    const copyStatus = root.querySelector('[data-copy-status]');
    if (copyButton) {
      copyButton.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(window.location.href);
          if (copyStatus) copyStatus.textContent = copyButton.dataset.successText || 'Link copied';
        } catch (error) {
          if (copyStatus) copyStatus.textContent = copyButton.dataset.errorText || 'Copy unavailable';
        }
        window.setTimeout(() => { if (copyStatus) copyStatus.textContent = ''; }, 2200);
      });
    }
  });
})();
